import { i18nTranslate } from 'src/utils'

const getTeamStatus = props => {
  const { isSearchStatusForm = false } = props
  const statuses = []
  if (isSearchStatusForm === true) {
    statuses.push({
      label: i18nTranslate('status.All', 'All'),
      value: '',
    })
  }
  statuses.push(
    {
      label: i18nTranslate('status.active', 'Active'),
      value: 'Active',
    },
    {
      label: i18nTranslate('status.inActive', 'Inactive'),
      value: 'Inactive',
    }
  )
  return statuses
}

const teamNames = [
  {
    label: i18nTranslate('teamNames.selectTeamName', 'Select Team Name'),
    value: '',
  },
  {
    label: i18nTranslate('teamNames.teamName1', 'Team Name 1'),
    value: 'Team Name 1',
  },
  {
    label: i18nTranslate('teamNames.teamName2', 'Team Name 2'),
    value: 'Team Name 2',
  },
  {
    label: i18nTranslate('teamNames.teamName3', 'Team Name 3'),
    value: 'Team Name 3',
  },
  {
    label: i18nTranslate('teamNames.teamName4', 'Team Name 4'),
    value: 'Team Name 4',
  },
]

const costCenterIds = [
  {
    label: 'All',
    value: '',
  },
  {
    label: i18nTranslate('costCenterId.id1', 'Cost center 1'),
    value: 'Cost center 1',
  },
  {
    label: i18nTranslate('costCenterId.id2', 'Cost center 2'),
    value: 'Cost center 2',
  },
  {
    label: i18nTranslate('costCenterId.id3', 'Cost center 3'),
    value: 'Cost center 3',
  },
  {
    label: i18nTranslate('costCenterId.id4', 'Cost center 4'),
    value: 'Cost center 4',
  },
]

const teamsData = [
  {
    id: 1,
    accountId: 1,
    costCenterId: 1,
    name: 'NUTS',
    description: 'NUTS',
    status: 'active',
    teamBuyer: [
      {
        id: 1,
        userId: '1',
        teamId: 1,
        accountId: 1,
      },
      {
        id: 2,
        userId: '2',
        teamId: 1,
        accountId: 1,
      },
    ],
  },
  {
    id: 2,
    accountId: 1,
    costCenterId: 2,
    name: 'NUTS 2',
    description: 'NUTS',
    status: 'expired',
    teamBuyer: [
      {
        id: 1,
        userId: '1',
        teamId: 1,
        accountId: 1,
      },
    ],
  },
]
//   {
//     name: 'Marketing Team',
//     selectedCostCenter: 'Platform',
//     selectedUsers: ['john@gmail.com', 'regina@gmail.com', 'sam@gmail.com'],
//     status: 'Inactive',
//     description: 'This team markets the product',
//   },
//   {
//     name: 'Product Team',
//     selectedCostCenter: 'Platform',
//     selectedUsers: ['john@gmail.com', 'regina@gmail.com', 'sam@gmail.com'],
//     status: 'Active',
//     description: 'This team develops the product',
//   },
// ]

export { teamsData, costCenterIds, teamNames, getTeamStatus }
